export default __webpack_public_path__ + "static/media/ios_qr.679ba5eb.png";